import { defineMessages } from "react-intl";
import { validator } from "lib/build/forms/ltx/phase-i/lab-procedures/autoimmun-lab-procedures/sma";
import { FieldData, FieldsetData } from "src/features/forms";
import { genericErrorMessages } from "src/messages/generic";
import { LeafNode } from "src/modules/shared/form-explorer";

const messages = defineMessages({
	sma: {
		id: "form.sma",
		defaultMessage: "SMA"
	},
	value: {
		id: "form.sma.value",
		defaultMessage: "Érték"
	}
});

const fields: { [key: string]: FieldData } = {
	value: {
		type: "field",
		path: ["value"],
		label: messages.value,
		errorMessages: genericErrorMessages,
		input: { type: "input", props: { type: "text" } }
	}
};

const fieldset: FieldsetData = {
	rows: [{ columns: [{ width: 12, field: fields.value }] }]
};

export const node: LeafNode = {
	id: "sma",
	value: {
		title: messages.sma,
		validator,
		fieldset,
		isImportant: true
	}
};
